import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const fetchPlaces = async (params = {}) => {
    try {
        const { page = 1, per_page = 12, region, type, query } = params;
        const response = await api.get('/places', {
            params: {
                page,
                per_page,
                region_id: region,
                type_id: type,
                search: query
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching places:', error);
        throw error;
    }
};

export const fetchPlaceDetails = async (id) => {
    try {
        const response = await api.get(`/places/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching place details:', error);
        throw error;
    }
};

export const fetchRegions = async () => {
    try {
        const response = await api.get('/regions');
        return response.data;
    } catch (error) {
        console.error('Error fetching regions:', error);
        throw error;
    }
};

export const fetchPlaceTypes = async () => {
    try {
        const response = await api.get('/place-types');
        return response.data;
    } catch (error) {
        console.error('Error fetching place types:', error);
        throw error;
    }
};

export const fetchRegionDetails = async (id) => {
    try {
        const response = await api.get(`/regions/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching region details:', error);
        throw error;
    }
};

export const fetchPlacesByRegion = async (regionId, params = {}) => {
    try {
        const { page = 1, per_page = 12, type, query } = params;
        const response = await api.get(`/regions/${regionId}/places`, {
            params: {
                page,
                per_page,
                type_id: type,
                search: query
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching places by region:', error);
        throw error;
    }
};